/**
 * Бренд-палитра Aelo для печатного отчёта («бумажная» тема — как email-шаблоны
 * и сайт). Это единственное место в ui-worker, где цвета заданы литералами:
 * документ печати не участвует в Meridian/Tailwind и рендерится в отдельном
 * окне браузера, где переменных темы приложения не существует.
 */
import { scoreBand } from '@/lib/scoreBand';

export const COLORS = {
  accent: '#3a9995',
  excellent: '#16a34a',
  good: '#3a9995',
  fair: '#d97706',
  poor: '#dc2626',
  paper: '#f7f5ef',
  card: '#ffffff',
  line: '#d9d5c7',
  lineSoft: '#efece3',
  fg: '#1a1c1e',
  fgMuted: '#4a4f55',
  fgSubtle: '#6b7280',
} as const;

export const FONTS = {
  display: "'Space Grotesk', Georgia, serif",
  ui: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  mono: "'JetBrains Mono', 'SF Mono', Consolas, monospace",
} as const;

/**
 * Ссылка на собственные шрифты — только внутри окна печати, на бандл не влияет.
 *
 * URL **абсолютный** намеренно: окно открывается как `window.open('', '_blank')`,
 * и в документе с адресом `about:blank` корневой путь `/fonts/...` резолвить
 * не от чего — отчёт молча печатается системным шрифтом. Origin берётся в
 * момент вызова, а не при импорте: модуль импортируется и в тестах, где
 * `window` может отсутствовать.
 */
export function fontsHref(): string {
  return `${window.location.origin}/fonts/fonts.css`;
}

export function scoreHex(score: number): string {
  return COLORS[scoreBand(score)];
}

/** Полупрозрачная заливка того же цвета — для чипов и плашек. */
export const TINT = {
  excellent: 'rgba(22,163,74,.1)',
  good: 'rgba(58,153,149,.1)',
  fair: 'rgba(217,119,6,.1)',
  poor: 'rgba(220,38,38,.1)',
  neutral: '#f0ede4',
} as const;

export function scoreTint(score: number): string {
  return TINT[scoreBand(score)];
}
